module.exports = {
  id: 30,
  name: 'Tricep Dips',
  categories: ['strength', 'arms', 'core'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 12,
  instructions:
    'Tricep Dips make your arms super strong! Sit on the ground with your hands behind you, lift your bottom up, then lower down and push back up!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to do tricep dips? Let us build incredible arm strength!',
    },
    {
      time: 3,
      text: 'Sit on the ground with your hands behind you, fingers pointing forward!',
    },
    {
      time: 6,
      text: 'Lift your bottom up and keep your core tight!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Bend your elbows and lower down slowly!',
    },
    // SET 1 - 10 tricep dips
    {
      time: 12,
      text: 'Perfect dip position! Hands behind you, bottom lifted!',
    },
    {
      time: 15,
      text: 'Number 1! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 18,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 21,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 24,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 27,
      text: 'Number 2! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 30,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 33,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 36,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 39,
      text: 'Number 3! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 42,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 45,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 48,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 51,
      text: 'Number 4! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 54,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 57,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 60,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 63,
      text: 'Number 5! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 66,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 69,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 72,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 75,
      text: 'Number 6! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 78,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 81,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 84,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 87,
      text: 'Number 7! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 90,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 93,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 96,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 99,
      text: 'Number 8! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 102,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 105,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 108,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 111,
      text: 'Number 9! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 114,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 117,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 120,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 123,
      text: 'Number 10! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 126,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 129,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 132,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 135,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 1 - 20 seconds
    {
      time: 138,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 141,
      text: 'Shake out your arms and hands, get ready for round two!',
    },
    {
      time: 144,
      text: 'You are doing amazing! Ready for round two? Let us keep going!',
    },
    {
      time: 147,
      text: 'Remember to keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 150,
      text: '3, 2, 1, START! Bend your elbows and lower down slowly!',
    },
    // SET 2 - 10 tricep dips
    {
      time: 153,
      text: 'Perfect dip position! Hands behind you, bottom lifted!',
    },
    {
      time: 156,
      text: 'Number 1! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 159,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 162,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 165,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 168,
      text: 'Number 2! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 171,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 174,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 177,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 180,
      text: 'Number 3! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 183,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 186,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 189,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 192,
      text: 'Number 4! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 195,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 198,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 201,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 204,
      text: 'Number 5! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 207,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 210,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 213,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 216,
      text: 'Number 6! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 219,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 222,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 225,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 228,
      text: 'Number 7! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 231,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 234,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 237,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 240,
      text: 'Number 8! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 243,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 246,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 249,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 252,
      text: 'Number 9! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 255,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 258,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 261,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 264,
      text: 'Number 10! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 267,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 270,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 273,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 276,
      text: 'Great job! Take a deep breath and shake out your arms.',
    },
    // REST PERIOD 2 - 20 seconds
    {
      time: 279,
      text: 'Take a deep breath in and out, you are building incredible arm strength!',
    },
    {
      time: 282,
      text: 'Shake out your arms and hands, get ready for the final round!',
    },
    {
      time: 285,
      text: 'You are doing amazing! Ready for the final round? Let us finish strong!',
    },
    {
      time: 288,
      text: 'Remember to keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 291,
      text: '3, 2, 1, START! Bend your elbows and lower down slowly!',
    },
    // SET 3 - 10 tricep dips
    {
      time: 294,
      text: 'Perfect dip position! Hands behind you, bottom lifted!',
    },
    {
      time: 297,
      text: 'Number 1! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 300,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 303,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 306,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 309,
      text: 'Number 2! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 312,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 315,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 318,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 321,
      text: 'Number 3! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 324,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 327,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 330,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 333,
      text: 'Number 4! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 336,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 339,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 342,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 345,
      text: 'Number 5! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 348,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 351,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 354,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 357,
      text: 'Number 6! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 360,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 363,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 366,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 369,
      text: 'Number 7! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 372,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 375,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 378,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 381,
      text: 'Number 8! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 384,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 387,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 390,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 393,
      text: 'Number 9! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 396,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 399,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 402,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 405,
      text: 'Number 10! Keep your hands behind you, fingers pointing forward!',
    },
    {
      time: 408,
      text: 'Bend your elbows and lower down slowly!',
    },
    {
      time: 411,
      text: 'Keep your core tight and use your triceps!',
    },
    {
      time: 414,
      text: 'Push back up using your triceps and core!',
    },
    {
      time: 417,
      text: 'Incredible work! You just completed all three sets!',
    },
    // COMPLETION
    {
      time: 420,
      text: 'Amazing work! You did 30 tricep dips and built incredible arm strength!',
    },
    {
      time: 423,
      text: 'You are getting super strong and powerful! You are a tricep master!',
    },
    {
      time: 426,
      text: 'Great job, strength champion! You are building incredible skills!',
    },
  ],
};
